import createAPIRequestId from '../helpers/createAPIRequestId'
import store from '../store/index'

export default async function useEditCampaignArtefact(artefact, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCampaignArtefact....')
  console.log('artefact:', artefact)

  if (artefact?.payload instanceof FormData) {
    const payloadEntries = []
    artefact.payload.forEach((value, key) => {
      if (value instanceof File) {
        payloadEntries.push([
          key,
          `${value.name} (${value.type || 'application/octet-stream'}, ${value.size} bytes)`,
        ])
      } else {
        payloadEntries.push([key, value])
      }
    })

    console.log('artefact payload (FormData entries):', payloadEntries)
  }

  const this_store = store

  let parm_id = ''
  let parm_partialInd = false

  if (artefact.id !== undefined && artefact.id !== null && artefact.id !== '') {
    parm_id = artefact.id
    parm_partialInd =
      artefact.partial !== undefined ? artefact.partial : artefact.action !== 'DELETE'
  }

  if (
    (artefact.action === 'UPDATE' || artefact.action === 'DELETE') &&
    (parm_id === '' || parm_id === null || parm_id === undefined)
  ) {
    throw new Error(
      'Missing campaign artefact id for ' + artefact.action + ' in useEditCampaignArtefact',
    )
  }

  const endpoint = 'api/v1/campaign-artefacts/'
  const request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }

  if (artefact.action === 'DELETE') {
    request_parms.deleteInd = true
  }

  const request = createAPIRequestId(request_parms)
  const api_parms = {
    api_request: request,
    api_preview: preview,
  }

  if (artefact.action !== 'DELETE') {
    api_parms.payload = artefact.payload
  }

  return this_store
    .dispatch('campaignArtefacts/editCampaignArtefact', api_parms)
    .then((res) => {
      if (preview) console.log('useEditCampaignArtefact preview result:', res)
      return res
    })
    .catch((err) => {
      console.error('editCampaignArtefact error:', err)
      throw err
    })
}
